import { render, staticRenderFns } from "./Cores.vue?vue&type=template&id=08959fb3&scoped=true&"
import script from "./Cores.vue?vue&type=script&lang=js&"
export * from "./Cores.vue?vue&type=script&lang=js&"
import style0 from "./cores.css?vue&type=style&index=0&id=08959fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08959fb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCardText,VChip,VDivider})
